import React, { useState } from 'react';
import tabStyles from 'assets/css/Tab.module.css';
import eventStyles from 'assets/css/Event.module.css';
import AceAnswersAvailableEvent from 'Components/Card/Components/AceAnswersAvailableEvent';
import AceAnswersRegisteredEvent from 'Components/Card/Components/AceAnswersRegisteredEvent';
import AceAnswersEventPartials, { ACE_ANSWERS_EVENT_CONSTANTS, aceAnswersEventHelpers } from 'Components/Card/Partials/Partials.AceAnswersEvent';
import useCard from 'context/CardContext';

function GoToEventCard(props) {
    const { cardTitle } = useCard();

    //local var(s)
    const { data } = props;
    const { Eligible: eligible } = data;

    //state(s)
    const [panel, setPanel] = useState(ACE_ANSWERS_EVENT_CONSTANTS.EVENT_TYPES.AVAILABLE);

    const AvailableEventsPanel = () => (
        <div className={"ace-answers-events ace-answers-events--available"} >
            <AceAnswersEventPartials.EventMap events={data.Available} eventType={AceAnswersAvailableEvent} eligible={eligible} />
        </div>
    );
    const RegisteredEventsPanel = () => (
        <div className={"ace-answers-events ace-answers-events--registered"} >
            <AceAnswersEventPartials.EventMap events={data.Registered} eventType={AceAnswersRegisteredEvent} eligible={eligible} cardTitle={cardTitle} />
        </div>
    );

    //render
    return (
        <div className={eventStyles.aceAnswersEventWrap}>
            <div className={tabStyles.tabWrap}>
                <div className={tabStyles.tabWrapInner}>
                    <AceAnswersEventPartials.EventSelector isActive={aceAnswersEventHelpers.isPanelDisplayAvailable(panel)} displayName={ACE_ANSWERS_EVENT_CONSTANTS.EVENT_TYPES.AVAILABLE} setPanel={setPanel} />
                    <AceAnswersEventPartials.EventSelector isActive={aceAnswersEventHelpers.isPanelDisplayRegistered(panel)} displayName={ACE_ANSWERS_EVENT_CONSTANTS.EVENT_TYPES.REGISTERED} setPanel={setPanel} />
                </div>
            </div>
            <div className={eventStyles.container}>
                {aceAnswersEventHelpers.isPanelDisplayAvailable(panel) && <AvailableEventsPanel />}
                {aceAnswersEventHelpers.isPanelDisplayRegistered(panel) && <RegisteredEventsPanel />}
            </div>
        </div>
    )
}

export default GoToEventCard;
